import React from "react";
import './About.css'

const About = () => {
  return (
    <section className='about-container'>
      <h1 className='about'>ABOUT</h1>
      <div className='about-section'>
        <h4>Hi there! Nice to meet you...</h4>
        <p className='professional'>I'm a software engineer specializing in JavaScript, Typescript, Angular, and React. I'm a huge believer in pushing myself outside my comfort zone, so I'm always looking for a challenge. I aspire to be in a career space where I am trusted to solve complex problems that have a positive impact on those around me and the company’s future. Part of the reason I transitioned into software engineering is because I knew each day would be challenging, and therefore rewarding. The more complex the problem, the greater chance for positive social impact. </p>
          
        <p className='personal'>I reside in Denver, Colorado with my two cats, Miso and Maki. Chances are you'll catch me with my nose in a book or watching movies in my spare time. My biggest personal achievement is trekking for three days from Kalaw to Inle Lake in Myanmar (in Birkenstocks, might I add). I hiked with a group of strangers (turned friends), slept in local homestays, ate the best food in the world, and gained a thousand blisters/ bruises. Though the best thing I left with was how to get comfortable being uncomfortable. </p>
        <p className='reference'>For more information regarding my skills and experience, please reference my resume below.</p>
      </div>
    </section>
  )
}

export default About